import Text from 'components/Text/Text';
import React from 'react';
import breadcrumbs from 'assets/img/breadcrumbs.svg';
import classNames from 'classnames';
import style from './SelectedItem.module.scss';

interface ISelectedItem {
	label: string | string[];
	onDelete?: () => void;
	separator?: string | JSX.Element;
	additionalContent?: JSX.Element;
	className?: string;
}

const SelectedItem: React.FC<ISelectedItem> = ({ label, onDelete, separator, additionalContent, className }) => {
	const containerClasses = classNames(style.container, className);

	const defaultSeparator = () => (
		<svg className={style.separatorIcon}>
			<use xlinkHref={`${breadcrumbs}#rightAngleArrow`} />
		</svg>
	);

	const isStringSeparator = typeof separator === 'string';

	const separatorElement = isStringSeparator ? <span className={style.separator}>{separator}</span> : separator;

	const singleContent = () => (
		<>
			<Text translationKey={label as string} theme="secondary" size="xs" withTooltip={true} />
			<div className={style.additionalContent}>
				{additionalContent}
				{onDelete ? (
					<div className={style.deleteBtn} onClick={onDelete}>
						<svg className={style.deleteIcon}>
							<use xlinkHref={`${breadcrumbs}#closeSelectItem`} />
						</svg>
					</div>
				) : null}
			</div>
		</>
	);

	const multipleContent = () => (
		<>
			<div className={style.labelRow}>
				{Array.isArray(label) &&
					label.map((el, i) => {
						const lastItem = i === label.length - 1;
						return (
							<React.Fragment key={el}>
								<Text translationKey={el} theme="secondary" size="s" withTooltip={true} />
								{!lastItem && (separator ? separatorElement : defaultSeparator())}
							</React.Fragment>
						);
					})}
			</div>
			<div className={style.additionalContent}>
				{additionalContent}
				{onDelete ? (
					<div className={style.deleteBtn} onClick={onDelete}>
						<svg className={style.deleteIcon}>
							<use xlinkHref={`${breadcrumbs}#closeSelectItem`} />
						</svg>
					</div>
				) : null}
			</div>
		</>
	);

	return (
		<div className={containerClasses} data-test="SelectedItem">
			{Array.isArray(label) ? multipleContent() : singleContent()}
		</div>
	);
};

export default React.memo(SelectedItem);
